



























import { Component, Vue } from 'vue-property-decorator';
import introInfo from '../introInfo';

export default {
	props: ['currentPage'],
	methods: {
		introTitle() {
			return this.currentPage ? introInfo.page[this.currentPage].heading : null;
		},
		introDescription() {
			return this.currentPage ? introInfo.page[this.currentPage].description : null;
		},
	},
};

